module.exports = __webpack_public_path__ + "assets/img/gargoyle-attack.a670f619.png";